module.exports = __webpack_public_path__ + "static/media/happy1.317a4775.svg";